<div class="task-template-selector"
     (click)="change($event)">
  <span class="task-template-selector--value">
      {{ value || placeholder }}
  </span>
</div>